import { useEffect, useState } from 'react';
import { FEATURED_PROJECTS_URL } from '../constants';

export const useFeaturedProjects = () => {
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [featuredStatus, setFeaturedStatus] = useState('loading');
  const [featuredError, setFeaturedError] = useState('');

  useEffect(() => {
    const controller = new AbortController();

    const fetchFeaturedProjects = async () => {
      setFeaturedStatus('loading');
      setFeaturedError('');

      try {
        const response = await fetch(FEATURED_PROJECTS_URL, {
          signal: controller.signal,
          headers: {
            Accept: 'application/vnd.github+json',
          },
        });

        if (!response.ok) {
          throw new Error('GitHub API request failed.');
        }

        const data = await response.json();
        const mappedProjects = data.map((repo) => ({
          id: repo.id,
          title: repo.name,
          description: repo.description || 'No description provided yet.',
          repoUrl: repo.html_url,
        }));

        setFeaturedProjects(mappedProjects);
        setFeaturedStatus('success');
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        setFeaturedError('Unable to load featured projects right now.');
        setFeaturedStatus('error');
      }
    };

    fetchFeaturedProjects();

    return () => controller.abort();
  }, []);

  return {
    featuredProjects,
    featuredStatus,
    featuredError,
  };
};
